<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="register-process-title">
      <div class="register-process-line"></div>
      <div class="register-process-text">注册审核</div>
    </div>

    <van-tabs v-model="tabActive" @click="onTabClick" color="#3a71ffff" title-active-color="#3a71ffff">
      <van-tab title="企业注册">
        <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1">
          <van-list v-model="loading1" :finished="finished1" finished-text="没有更多了" @load="onLoad1"
            :immediate-check=false>
            <van-cell-group v-for="(item, index) in list1" :key="index" style="margin-top: 12px;" inset>
              <van-cell title="企业名称" :value="item.enterpriseName" :border="false" />
              <van-cell title="企业税号" :value="item.enterpriseCode" :border="false" />
              <van-cell title="负责人姓名" :value="item.name" :border="false" />
              <van-cell title="负责人身份证号" :value="item.identityCard" :border="false" />
              <van-cell title="负责人性别" :value="getSexStr(item.sex)" :border="false" />
              <van-cell title="负责人电话" :value="item.account" :border="false" />
              <van-cell title="日期" :value="item.updateTime" :border="true" />
              <div class="register-process-container">
                <div class="register-process-item" @click="onClickRefuse(item)">拒绝</div>
                <div class="register-process-divider"></div>
                <div class="register-process-item" style="color: #3a71ffff;" @click="onClickAgree(item)">同意</div>
              </div>
            </van-cell-group>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="个人注册">
        <van-pull-refresh v-model="refreshing2" @refresh="onRefresh2">
          <van-list v-model="loading2" :finished="finished2" finished-text="没有更多了" @load="onLoad2"
            :immediate-check=false>
            <van-cell-group v-for="(item, index) in list2" :key="index" style="margin-top: 12px;" inset>
              <van-cell title="姓名" :value="item.name" :border="false" />
              <van-cell title="电话" :value="item.account" :border="false" />
              <van-cell title="身份证号" :value="item.identityCard" :border="false" />
              <van-cell title="性别" :value="getSexStr(item.sex)" :border="false" />
              <van-cell title="日期" :value="item.updateTime" :border="true" />
              <div class="register-process-container">
                <div class="register-process-item" @click="onClickRefuse(item)">拒绝</div>
                <div class="register-process-divider"></div>
                <div class="register-process-item" style="color: #3a71ffff;" @click="onClickAgree(item)">同意</div>
              </div>
            </van-cell-group>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <van-dialog v-model="showDialog" :show-confirm-button="false" ref="dialog">
      <van-col class="register-process-register">
        <div>拒绝原因</div>
        <van-field v-model="refuseNoPass.remark" placeholder="请输入拒绝原因" rows="5" type="textarea"
          class="register-process-edit" clearable />
        <van-button round type="info" style="width: 100%;" @click="onClickRefuseSub">确定</van-button>
      </van-col>
    </van-dialog>

  </van-col>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';
import user from '@/utils/user'

export default {
  data() {
    return {
      duty: -1,
      tabActive: 0,
      showDialog: false,
      list1: [],
      loading1: false,
      finished1: false,
      refreshing1: false,
      listQuery1: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        status: 4,
      },
      list2: [],
      loading2: false,
      finished2: false,
      refreshing2: false,
      listQuery2: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        status: 1,
      },
      refuseNoPass: {
        id: "",
        remark: "",
      },
    };
  },
  created() {
    this.duty = user.getUserDuty()

    if (this.duty == 99) {
      this.onRefresh1()
      this.onRefresh2()
    } else {
      this.$router.replace({ name: 'noPermission' });
    }
  },
  methods: {
    getSexStr(value) {
      var s = ""
      if (value == 0) {
        s = "男"
      } else {
        s = "女"
      }
      return s;
    },
    onTabClick() {

    },
    onClickRefuse(item) {
      this.refuseNoPass.id = item.id;
      this.showDialog = true;
    },
    onClickRefuseSub() {
      var filterFomr = Object.assign({}, this.refuseNoPass);
      request.post("/User/AccountAudit/NoPass", filterFomr)
        .then(() => {
          Toast("操作成功")
          if (this.tabActive == 0) {
            this.onRefresh1()
          } else {
            this.onRefresh2()
          }
        })
        .catch(() => { });
      this.showDialog = false;
    },
    onClickAgree(item) {
      request.get("/User/AccountAudit/Pass", { params: { id: item.id } })
        .then(() => {
          Toast("操作成功")
          if (this.tabActive == 0) {
            this.onRefresh1()
          } else {
            this.onRefresh2()
          }
        })
        .catch(() => { });
    },
    onLoad1() {
      if (this.refreshing1) {
        this.list1 = [];
        this.refreshing1 = false;
        this.listQuery1.page = 1;
      }

      var filterFomr = Object.assign({}, this.listQuery1);
      request.post("/User/AccountAudit/Query", filterFomr).then((res) => {
        this.listQuery1.page = res.data.data.pageInfo.page + 1;
        this.list1 = res.data.data.data;
        this.finished1 = !res.data.data.pageInfo.hasMore;
        this.loading1 = false;
      }).catch(() => {
        this.loading1 = false;
      });
    },
    onRefresh1() {
      // 清空列表数据
      this.finished1 = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading1 = true;
      this.onLoad1();
    },
    onLoad2() {
      if (this.refreshing2) {
        this.list2 = [];
        this.refreshing2 = false;
        this.listQuery2.page = 1;
      }

      var filterFomr = Object.assign({}, this.listQuery2);
      request.post("/User/AccountAudit/Query", filterFomr).then((res) => {
        this.listQuery2.page = res.data.data.pageInfo.page + 1;
        this.list2 = res.data.data.data;
        this.finished2 = !res.data.data.pageInfo.hasMore;
        this.loading2 = false;
      }).catch(() => {
        this.loading2 = false;
      });
    },
    onRefresh2() {
      // 清空列表数据
      this.finished2 = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading2 = true;
      this.onLoad2();
    },
  }
};
</script>

<style lang="less">
.register-process-container {
  display: flex;
  align-items: center;
  /* 垂直居中 */
}

.register-process-item {
  flex: 1;
  /* 让项目平分容器宽度 */
  text-align: center;
  /* 文本居中 */
}

.register-process-divider {
  width: 1px;
  /* 分割线的宽度 */
  height: 40px;
  /* 分割线的高度，根据需要调整 */
  background-color: #f7f7f7;
  /* 分割线的颜色 */
}

.register-process-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.register-process-tags {
  display: flex;
  align-items: center;
}

.register-process-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.register-process-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.register-process-text {
  color: #333;
  margin-left: 6px;
}

.register-process-register {
  width: 100%;
  padding: 20px;
}

.register-process-edit {
  background: #3a71ff1a;
  border: 1px solid #3a71ffff;
  border-radius: 12px;
  margin: 12px 0px;
}
</style>
